import { createApp } from '../../redux/actions/appActions';
import { connect } from 'react-redux';
import CreateAppForm from './CreateAppForm';

const mapStateToProps = ({
  apps: { adding, error },
  form: { CreateAppForm }
}) => {
  return {
    initialValues: { platform: 'Android' },
    errorMessage:
      CreateAppForm && CreateAppForm.submitSucceeded && error && error.message,
    adding
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ appName, platform, url }) =>
    dispatch(createApp({ name: appName, platform, url }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAppForm);



// WEBPACK FOOTER //
// ./src/components/createApp/CreateAppFormContainer.js